module.exports = __webpack_public_path__ + "img/sany_logo.7b12f157.png";